"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSumGasUsed = void 0;
const getSumGasUsed = (txns) => txns.reduce((prev, txn) => {
    var _a;
    return Number((_a = txn === null || txn === void 0 ? void 0 : txn.gasUsed) !== null && _a !== void 0 ? _a : 0) + prev;
}, 0);
exports.getSumGasUsed = getSumGasUsed;
